module.exports = __webpack_public_path__ + "img/574.4bacce31.jpg";